'use strict';

var complex = require('./complex.cjs');
var number = require('./number.cjs');

function mix(from, to, p) {
    if (typeof from === "number" &&
        typeof to === "number" &&
        typeof p === "number") {
        return number.mixNumber(from, to, p);
    }
    const mixer = complex.getMixer(from);
    return mixer(from, to);
}

exports.mix = mix;
//# sourceMappingURL=index.cjs.map
